import React from 'react';
import AlertMessages from "../../../../../components/messages/alert-message.js";
import projectUtils from "../../../../../utils/project-utils.js";

const fieldError = {
    "user.name": ["missing.name"],
    "user.cpf": ["cpf.already.in.use", "missing.cpf", "cpf.invalid"],
    "user.address.type": ["invalid.address_type"],
    "user.profile.sex": ["sex.invalid"],
    "user.profile.educationLevel": ["educationLevel.invalid"],
    "user.profile.maritalStatus": ["maritalStatus.invalid"],
    "user.userTeamId": ["userTeamId.invalid"],
    "user.documents.expeditionRg": ["expeditionRg.invalid"],
    "user.documents.emitterCnh": ["emitterCnh.invalid"],
    "user.documents.expirationCnh": ["expirationCnh.invalid"],
    "user.documents.categoryCnh": ["categoryCnh.invalid"],
    "user.documents.emitterWork": ["emitterWork.invalid"],
    "cellPhone": ["cellphoneNumber.invalid", "celular.already.exists", "celular.sent.multiple.time"],
    "residentialPhone": ["residentialNumber.invalid", "residencial.already.exists", "residentialNumber.sent.multiple.time"],
    "user.profile.dtBirth": ["dtBirth.invalid"],
    "user.login": ["login.already.exists", "invalid.login"],
    "user.nameWar": ["nameWar.already.exists"],
    "teamName": ["userTeamId.invalid"],
}

const ImportCellRenderer = ({data, colDef, value}) => {
    let errorMessage = ""
    const find = fieldError[colDef.field]?.find(m => data.errors?.includes(m));
    if (find) errorMessage = AlertMessages[find] ?? ""

    let valueFormated = value;
    if (colDef.field === "user.documents.categoryCnh") valueFormated = value ? value.join(", ") : "";

    if (["user.profile.dtBirth", "user.documents.expeditionRg", "user.documents.emitterCnh",
        "user.documents.expirationCnh", "user.documents.emitterWork", "user.profile.admission"].includes(colDef.field)) {
        valueFormated = value ? projectUtils.formatDate(value + " 00:00:00", 'DD/MM/YYYY') : null;
    }

    return <div className={`${errorMessage ? "bg-[#f8d7da] w-full h-full absolute left-0 flex items-center pl-[5px]" : ""} `} title={errorMessage}>
        {valueFormated ?? value}
    </div>;
};

export default ImportCellRenderer;